var render, staticRenderFns
import script from "./UiButton.vue?vue&type=script&lang=ts"
export * from "./UiButton.vue?vue&type=script&lang=ts"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=955ebe6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports